<template>
  <a-modal
    :visible="ShowPanel"  :mask="false" width="50%"
    title="封禁账户"
    @ok="handleOk()"
    @cancel="handleCancel()">
    <a-form >
      <a-form-item label="账户" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-select  v-model="advertiser" @change="getSpendRebate"
                  show-search
                  optionFilterProp="label" placeholder="请选择账户">
          <a-select-option :value="advertiserItem.advertiser_id"
                           :key="advertiserItem.advertiser_id"
                           :label="advertiserItem.name+advertiserItem.advertiser_id"
                           v-for="advertiserItem in advertiserList">
            {{advertiserItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="日期" :label-col="{ span: 7 }" :wrapper-col="{ span:16 }">
        <a-range-picker v-model="date" @change="getSpendRebate"
                        valueFormat="YYYY-MM-DD" />
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }" :data-source="tableData"
             :rowKey="item=>item.date" :loading="tableLoad"
             bordered :pagination="false">
      <template slot="date" slot-scope="text,recode">
        {{date[0]}} - {{date[1]}}
      </template>
      <template slot="advertiser_name" slot-scope="text,recode">
        {{recode.advertiser_name}}({{recode.advertiser}})
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import {CloseAdvertiser, GetAccountAdvertiser, GetSpendRebate} from "../../../api/v1/spend_rebate_api";

export default {
  name: "ClosePanel",
  props: ["ShowPanel"],
  data(){
    return {
      date:[],
      advertiser:'',
      tableLoad:false,
      tableData:[],
      advertiserList:[],
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        { title: '日期', dataIndex: 'date',scopedSlots: { customRender: 'date' },align:'center'},
        { title: '账户', dataIndex: 'advertiser_name',scopedSlots: { customRender: 'advertiser_name' },align:'center'},
        { title: '国家', dataIndex: 'country',align:'center'},
        { title: '有效消耗', dataIndex: 'spend', scopedSlots: { customRender: 'spend' },align:'center'},
      ]
      return _table_columns
    }
  },
  mounted() {
    GetAccountAdvertiser({}).then(resp => {
      if (resp.code===200){
        this.advertiserList = resp.data.advertiser_list
      }
    })
  },
  methods:{
    getSpendRebate(){
      GetSpendRebate({
        advertiser:this.advertiser,
        date:this.date
      }).then(resp => {
        if (resp.code===200){
          this.tableData = resp.data.list
          this.date = resp.data.date
        }
      })
    },
    handleOk(){
      CloseAdvertiser({
        advertiser:this.advertiser,
        date:this.date
      }).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.handleCancel()
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.advertiser = ''
      this.date = []
      this.tableData = []
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Rebate/ClosePanel.vue